export const timeSheetEN = {
    "timeSheetApp": {
        "first": "First shift ",
        "end": "Second shift ",
        "title" : " Timesheet " ,
        "to" : " to "
    },
    "paid": {
        "true": "Paid ",
        "false": "No Paid",
    },
    "punish": {
        "true": "no Penalty",
        "false": "Penalty",
    },
}